<!-- <div> -->
<div
  [routerLink]="['/' + item?.type + 's', item.individual.year + '_' + item.individual.individual]"
  class="observation-item"
  data-test-id="observation-item"
>
  <div class="observation-item__image_container">
    <img
      class="observation-item__image"
      data-test-id="observation-item__image"
      *ngIf="item.imgUrl$ | async"
      [src]="item.imgUrl$ | async"
    />
  </div>
  <div class="observation-item__description">
    <div class="observation-item__name">
      <div class="observation-item__label" data-test-id="observation-item__species">
        {{ item.species?.de | translate }}
      </div>
      <div class="observation-item__value" data-test-id="observation-item_name">{{ item.individual.name }}</div>
    </div>
    <div class="observation-item__observation">
      <div class="observation-item__label" *ngIf="item.individual.last_observation_date">
        {{ 'Letzte Beobachtung' | translate }},
        {{ getLastObservationDate() }}
      </div>
      <div class="observation-item__label" *ngIf="!item.individual.last_observation_date">
        {{ 'Noch keine Beobachtungen' | translate }}
      </div>
      <div class="observation-item__value" *ngIf="item.lastPhenophase">
        <span
          class="observation-item__phenophase-circle"
          [ngStyle]="{ 'background-color': getColor(item.individual.last_phenophase) }"
        ></span>
        {{ item.lastPhenophase.de | translate }}
      </div>
    </div>
  </div>
  <mat-icon svgIcon="arrow-right"></mat-icon>
</div>
